import _ from 'lodash';
import React from 'react';
import { MdSave } from 'react-icons/md';
import Crud from '~/components/crud';
import { formats } from '~/helper';
import { EventTypeForm, EventTypeSchema } from '~/views/event-types/form';
import { Container } from '~/views/event-types/styles';
import CellStatus from '~/components/datatable/cell-status';
import useEventTypes from '~/view-data/use-event-types';

const columns = [
  {
    name: '# Nome',
    selector: 'name',
    cell: (row) => {
      return (
        <CellStatus title={row.name} color={row.active ? '#53d449' : '#e6467f'}>
          <strong>{row.name}</strong>
        </CellStatus>
      );
    },
  },
  {
    name: 'Cadastrado em',
    selector: 'createdAt',
    hide: 'md',
    width: '140px',
    format: (row) => formats.dateTimeZone(_.get(row, 'createdAt'), 'dd/MM/yyyy HH:mm')
  },
];

function EventTypes({ acls }) {
  const canWrite = acls.includes('W');
  const { state, actions } = useEventTypes();

  return (
    <Container>
      <Crud
        columns={columns}
        emptyText='Nenhum tipo de evento encontrado'
        data={state.data}
        hideAdd={!canWrite}
        tableLoading={state.loading}
        formLoading={state.formLoading}
        formTitle={(data) => (_.get(data, 'id')) ? `Tipo de evento #${data.id}` : `Novo Tipo de evento`}
        onChangePage={actions.pageChange}
        onRowClicked={actions.load}
        formOptions={{
          validationSchema: EventTypeSchema,
          initialValues: state.model,
          initialTouched: { identify: true },
        }}
        renderForm={(args) => <EventTypeForm {...args} previewMode={!canWrite} />}
        actions={[
          {
            label: 'Salvar',
            icon: MdSave,
            isSubmit: true,
            isDisabled: ({ isValid }) => !isValid || !canWrite,
            action: actions.createOrUpdate,
          },
        ]}
      />
    </Container>
  );
}

export default EventTypes;
